/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { displayMessage, postAPI, getAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Space,
  Button,
  Card,
  Popconfirm,
  Avatar,
  Layout,
  Table,
  Tag,
  Input,
  Tooltip,
} from "antd";
import {
  ALL_PRODUCT,
  DELETE_PRODUCT,
  IMAGE_BASE_URL,
} from "../../constants/api";
import { CURRENCY } from "../../constants/constent";

function ProductTable() {
  const { Content } = Layout;
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const rData = data["data"].map((row, index) => ({
          key: index,
          id: index + 1,
          title: row.title,
          price: `${CURRENCY} ${row.price}`,
          sub_category: row.sub_category.name,
          category: row.sub_category.category.title,
          sub_category_tag: (
            <span>
              <Tag color="orange">{row.sub_category.category.title}</Tag>
              <Tag color="processing">{row.sub_category.name}</Tag>
            </span>
          ),
          brand: row.brand.title,
          brand_tag: <Tag color="processing">{row.brand.title}</Tag>,
          image: (
            <Avatar.Group shape="square">
              {row.sliders.map((item) => (
                <Avatar
                  shape="square"
                  src={IMAGE_BASE_URL + item.files.filePath}
                />
              ))}
            </Avatar.Group>
          ),
          avl_stock: (
            <Tooltip
              title={
                `Available Stock: ` +
                row.avl_stock +
                ` | Max Stock: ` +
                row.min_cart
              }
            >
              <Tag
                color={`${row.avl_stock <= row.min_cart ? "error" : "green"}`}
              >
                QTY: {row.avl_stock}
              </Tag>
            </Tooltip>
          ),
          sku_code: row.sku_code,
          barcode: row.barcode,
          action: (
            <Space>
              <Button
                loading={loading}
                disabled={loading}
                onClick={() => {
                  navigate("/product/edit/" + row.id);
                }}
                block
              >
                Edit
              </Button>
              <Popconfirm
                title="Delete the data"
                description="Are you sure to delete this data?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button loading={loading} disabled={loading} danger>
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          ),
        }));
        setState(rData);
        setFilteredData(rData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_PRODUCT, successFn, errorFn, {});
  };

  const deleteData = (values) => {
    setLoading(true);
    let data = {
      id: values,
    };
    const successFn = function (data) {
      if (data.status === true) {
        setLoading(false);
        getData();
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Delete Data");
    };
    postAPI(DELETE_PRODUCT, data, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.sku_code.toLowerCase().includes(value.toLowerCase()) ||
        room.barcode.toLowerCase().includes(value.toLowerCase()) ||
        room.title.toLowerCase().includes(value.toLowerCase()) ||
        room.category.toLowerCase().includes(value.toLowerCase()) ||
        room.sub_category.toLowerCase().includes(value.toLowerCase()) ||
        room.price.toString().includes(value)
    );
    setFilteredData(filtered);
  };

  const columns = [
    {
      title: "Sno",
      dataIndex: "id",
      width: 50,
    },
    {
      title: "SKU",
      dataIndex: "sku_code",
      width: 50,
    },
    {
      title: "Barcode",
      dataIndex: "barcode",
      width: 50,
    },
    {
      title: "Image",
      dataIndex: "image",
      width: 50,
    },
    {
      title: "Category | Sub",
      dataIndex: "sub_category_tag",
      width: 50,
    },
    {
      title: "Brand",
      dataIndex: "brand_tag",
      width: 50,
    },
    {
      title: "Title",
      dataIndex: "title",
      width: 150,
    },
    {
      title: "Price",
      dataIndex: "price",
      width: 50,
    },
    {
      title: "Stock",
      dataIndex: "avl_stock",
      width: 50,
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 100,
    },
  ];

  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Manage Product"
            extra={
              <Space>
                <Input
                  placeholder="Search by Name or Category"
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  style={{ width: 300 }}
                />
                <Button onClick={() => navigate("/product/add")}>
                  Add <PlusOutlined />
                </Button>
              </Space>
            }
            bordered={true}
          >
            <Table
              loading={loading}
              columns={columns}
              dataSource={filteredData}
              pagination={{ pageSize: 10 }}
              scroll={{ x: 240 }}
            />
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}

export default ProductTable;
